/**
 * Canonical dietary restriction IDs and slugs used in quiz prefs and API payloads.
 */

/** Numeric dietary restriction IDs used in quiz prefs and API payloads. */
export enum DietaryRestrictions {
  Omnivore = 11,
  Vegan = 1,
  Vegetarian = 2,
  Pescatarian = 3,
  DairyFree = 4,
  GlutenFree = 5,
  SoyFree = 6,
  TreeNutFree = 7,
  PeanutFree = 8,
  EggFree = 9,
  ShellfishFree = 10,
  Flexitarian = 12,
  SesameFree = 15,
  GrainFree = 17,
  GarlicFree = 13,
  OnionFree = 14,
  CaffeineFree = 16,
}

/** Kebab-case dietary restriction slugs used in quiz state. */
export enum Dietary {
  DairyFree = 'dairy-free',
  GlutenFree = 'gluten-free',
  SoyFree = 'soy-free',
  TreeNutFree = 'tree-nut-free',
  PeanutFree = 'peanut-free',
  EggFree = 'egg-free',
  ShellfishFree = 'shellfish-free',
  SesameFree = 'sesame-free',
  GrainFree = 'grain-free',
  GarlicFree = 'garlic-free',
  OnionFree = 'onion-free',
  CaffeineFree = 'caffeine-free',
}
